import Title from '/@/components/title';
import { _ } from '/@/locale';
import styles from './styles.module.css';

export const BrandValues = (productDatasheet) => {
    return (
        <div>
            <Title size='xl' underline={true} className={styles.informationTitle}>
                {_('Pilares de la marca')}
            </Title>
            <div>{_(productDatasheet.productDatasheet.brandValuesIntroduction)}</div>
            {productDatasheet.productDatasheet.brandValues.map((brandValue) => {
                return (
                    <div key={brandValue.id} className={styles.brandValue}>
                        <div className={styles.name}>{_(brandValue.title)}</div>
                        <div>{_(brandValue.text)}</div>
                    </div>
                );
            })}
        </div>
    );
};
